export default "/fonts/vendor/mdui/dist/roboto/Roboto-Thin.woff2?e11b2308d1ace9c25083c7bd0fb9b66e";